<template>
<div>
  <privacy-policy></privacy-policy>
  <terms-of-service></terms-of-service>
</div>
</template>

<script>
// @ is an alias to /src
import privacyPolicy from './PrivacyPolicy.vue'
import termsOfService from './TermsOfService.vue'
export default {
  data () {
    return {
    }
  },
  components: {
    privacyPolicy,
    termsOfService
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
